import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { Node } from '@alfresco/js-api';
import { NodePermissionService, isLocked } from '@alfresco/aca-shared';

@Component({
  selector: 'aca-tags-tab',
  template: `

  <ng-container>



        <aca-add-existing-tag-action [nodeId]="nodeId">
        </aca-add-existing-tag-action>


  </ng-container>
  `
})
export class TagsTabComponent implements OnInit, OnChanges {
  @Input()
  node?: Node;

  nodeId!:string;

  hasTags = false;
  isFileSelected = false;

  constructor(private permission: NodePermissionService) {
  }

  ngOnInit() {
    this.updateState();

    // if (this.node && this.node.isFile) {
    //   this.showTag = true;
    //   //console.log('showTag ', this.showTag);
    // }
    //console.log('hasTags ', this.hasTags);
  }

  ngOnChanges() {
    this.updateState();
  }

  private updateState() {
    //console.log('Tags: updateState comp node', this.node);

    if(this.node){
      this.nodeId = this.node.id;
    }

    if (this.node?.properties) {
      // workaround for shared files type.
      this.hasTags = this.node.properties['cm:taggable'] != undefined;
    }
  }

  get canUpdateNode(): boolean {
    if (!this.node) {
      return false;
    }

    if (
      this.node.isFolder ||
      (this.node.isFile && !isLocked({ entry: this.node }))
    ) {
      return this.permission.check(this.node, ['update']);
    }
    return false;
  }
}
